module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep3-f484ca9ecd3bdb5e3f71fdbdc69d0130.png";